import { Component, Input, OnDestroy, OnInit, trigger, state, style, transition, animate } from "@angular/core";
import { AlertController } from "ionic-angular";
import * as common from '../../directives/common';
import { TranslateService } from "ng2-translate";

@Component({
    selector: 'open-result-tbl',
    template: `
        <div *ngIf="flagAlert" id="resultTbl" class="resultTbl">
            <div [@flyInOut]="state" class="open__resulttbl">
                <div class="clearfix" [innerHTML]="htmlResult"></div>
                <div class="closeBtn" (click)="closeResult()">OK</div>
            </div>
        </div>
    `,
    animations: [
        trigger('flyInOut', [
            state('inactive', style({
                opacity: 0,
                transform: 'scale(.5)'
            })),
            state('active', style({
                opacity: 1,
                transform: 'scale(1)'
            })),
            transition('inactive => active', animate('100ms ease-in')),
        ])
    ]
})

export class OpenResultTbl implements OnDestroy, OnInit {
    private timeoutClose: any;
    private flagAlert: boolean = false;
    private htmlResult: string;
    state: string;
    @Input() lotteryID: any;
    @Input() methodID: any;
    @Input()
    set openRecord(obj: any) {
        console.log('obj',obj);
        
        this.state  = 'inactive';
        if ( obj.nums.indexOf('') > -1 ) {
            obj.nums.splice(obj.nums.indexOf(''), 1);
        }
        if ( obj.nums.length <= 0 ) return;
        if (obj.hasOwnProperty('type')) {
            let titleAlert = '';
            this.htmlResult = common.separateType(obj.nums, obj.type, this.translate);
            if (obj.type === 0) { // dau-duoi
                titleAlert = this.translate.instant('HEAD')+'-'+this.translate.instant('TAIL');    
            }else if (obj.type === 1) { // duoi-dau
                titleAlert = this.translate.instant('TAIL')+'-'+this.translate.instant('HEAD');
            }
            let alertFirstLastNum = this.alertCtrl.create({
                title: titleAlert +' ['+obj.issue+']',
                message: '<div class="open__resulttbl">'+this.htmlResult+'</div>',
                cssClass: 'resultTbl resultTblDetail',
                buttons: [
                    {
                        text: 'OK',
                        handler: () => {
                            alertFirstLastNum.dismiss();
                        }
                    }
                ]
            });
            alertFirstLastNum.present();
        }else {
            this.flagAlert = true;
            let htmlTable = common.displayIssue(obj.nums, this.translate,this.lotteryID, this.methodID);
            
            this.htmlResult = '<div class="title__result">'+this.translate.instant('DRAW_RESULT')+' <span class="issue__name">'+obj.issue+'</span></div>' + htmlTable;
            this.htmlResult += this.numDauDuoi(obj);
            clearTimeout(this.timeoutClose);
            this.timeoutClose = setTimeout(()=>{
                this.flagAlert = false;
            }, 10000);
            setTimeout(()=>{
                this.state = 'active';
            },300);
        }
    }

    numDauDuoi(obj: any) {
        return common.separateType(obj.nums, 0, this.translate);
    }

    constructor(
        private alertCtrl: AlertController,
        private translate: TranslateService
    ){}

    closeResult() {
        this.flagAlert = false;
        clearTimeout(this.timeoutClose);
    }

    ngOnDestroy() {

    }

    ngOnInit() {

    }
}


// WEBPACK FOOTER //
// ./src/component/openResultTbl/openResultTbl.ts